module.exports = __webpack_public_path__ + "img/logo.14f86d81.jpg";